import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import { InvestmentInstructionsVisualizationComponent } from '../investment-instructions-visualization.component';
import { InvestmentInstruction } from '../../../../../models/transactions/investment-instruction';
import { InvestmentInstructionSubmissionInstructionData } from '../../../../../models/submissions/investment-instruction-submission-instruction-data';

@Component({
  selector: 'app-future-instructions-visualization',
  templateUrl: './future-instructions-visualization.component.html',
  styleUrls: ['./future-instructions-visualization.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FutureInstructionsVisualizationComponent
  extends InvestmentInstructionsVisualizationComponent
  implements OnChanges
{
  @Input() instructions: InvestmentInstruction[] | InvestmentInstructionSubmissionInstructionData[] = [];
  @Input() label: string = $localize`New`;

  @ViewChildren('grid') gridElements!: QueryList<ElementRef>;

  public ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    // If no forced columns are set, calculate using the length of the instructions array
    if (changes.instructions && !this.forcedColumns) {
      this._forcedColumns.next(this.instructions?.length ?? 0);
    }
  }
}
